import React, { useState } from "react";
import {
  Box,

  Modal,

} from "@mui/material";
import { modalstyle } from "../../../../Components/Popups/PopupsStyling";
import PopupTitle from "../../../../Components/Popups/PopupComponent/PopupTitle";
import ManagePriceRange from "./ManagePriceRange";

const AddUpdateDiscount = ({ modalcontrols, editeData }) => {
  // let popuptitle = editeData == null ? "Add Discount" : "Edit Discount";
  return (
    <>
      <Modal
        open={modalcontrols?.iseditpopup}
        onClose={modalcontrols?.closeeditpopup}
      >
        <Box
          sx={{
            ...modalstyle,
            borderRadius: "10px",
            width: { xs: "50vw", md: "40vw" },
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {/* <PopupTitle popuptitle={popuptitle} /> */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <ManagePriceRange
              modalcontrols={modalcontrols}
              data={editeData ? editeData : null}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AddUpdateDiscount;
